"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WS_CONNECTION_NODE_ID = exports.NODEID_COOKIE_KEY = exports.MSG_SHARD = exports.MSG_NUM = exports.META_HANDSHAKE = exports.MESSAGE_REDELIVERY_OPTIONS = exports.GLIDE_REMEMBER_ME = exports.GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC = exports.CHANNEL_READY_TO_DELIVER = exports.CHANNEL_NOT_READY_TO_DELIVER = void 0;
// Redelivery
var MSG_NUM = 'msg_num';
exports.MSG_NUM = MSG_NUM;
var MSG_SHARD = 'msg_shard';
exports.MSG_SHARD = MSG_SHARD;
var MESSAGE_REDELIVERY_OPTIONS = 'msg_redelivery_options';
exports.MESSAGE_REDELIVERY_OPTIONS = MESSAGE_REDELIVERY_OPTIONS;
var CHANNEL_READY_TO_DELIVER = 'Channel set to deliver messages now: ';
exports.CHANNEL_READY_TO_DELIVER = CHANNEL_READY_TO_DELIVER;
var CHANNEL_NOT_READY_TO_DELIVER = 'Channel set to not deliver messages until re-subscription & re-delivery of missed messages is over: ';
exports.CHANNEL_NOT_READY_TO_DELIVER = CHANNEL_NOT_READY_TO_DELIVER;
var META_HANDSHAKE = '/meta/handshake';
exports.META_HANDSHAKE = META_HANDSHAKE;
var WS_CONNECTION_NODE_ID = 'glide.amb.wsConnectionNodeId';
exports.WS_CONNECTION_NODE_ID = WS_CONNECTION_NODE_ID;
var NODEID_COOKIE_KEY = "glide_node_id_for_js";
exports.NODEID_COOKIE_KEY = NODEID_COOKIE_KEY;
var GLIDE_REMEMBER_ME = "glide.remember.me";
exports.GLIDE_REMEMBER_ME = GLIDE_REMEMBER_ME;
var GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC = "glide.amb.hup.signal.reconnect.in.sec";
exports.GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC = GLIDE_AMB_HUP_SIGNAL_RECONNECT_IN_SEC;